import { useState, useEffect, useContext } from "react";
import { useLazyGetDialogByIdQuery } from "src/store/chat/api";
import { ChatSocketIoContext } from "src/shared-features/Wrappers";
import { createDialogfromApi } from "../helpers";
import { Dialog } from "../types";

export const useReceiveNewDialog = () => {
  const chatSocket = useContext(ChatSocketIoContext);
  const [getDialogById, getDialogByIdState] = useLazyGetDialogByIdQuery();

  const [newDialog, setNewDialog] = useState<Dialog | null>(null);

  //new dialog [concern]
  useEffect(() => {
    if (!chatSocket?.chatSocket)
      return;

    const newDialogHandler = ({ chat_id }: { chat_id: string }) => {
      getDialogById({ dialogId: chat_id });
    };

    chatSocket?.chatSocket.on("newDialog", newDialogHandler);
    return () => {
      chatSocket?.chatSocket?.off("newDialog", newDialogHandler);
    };

  }, [chatSocket?.chatSocket]);

  useEffect(() => {
    if (!getDialogByIdState.data)
      return;

    const d = getDialogByIdState.data;
    setNewDialog(createDialogfromApi(d));

  }, [getDialogByIdState.data]);


  return newDialog;
};
